import _ from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';

import {
  SocialFeedTypes,
}                        from 'app/constants';
import SocialDuck        from 'app/ducks/social';
import history           from 'app/history';
import paths             from 'app/paths';
import reducerUtils      from 'app/reducers/utils';
import EntitiesSlx       from 'app/selectors/entities';
import RoutingSlx        from 'app/selectors/routing';



/*
 *  Actions
 */

const Types = {
  LOAD: 'PAGE_FEED_LOAD',
};

const Ax = {

  load: ({query}) => (dispatch, getState) => {
    const key = `${Math.random()}`;
    const promise = Promise.all([
      dispatch(SocialDuck.Ax.listingsSearch({feedType: SocialFeedTypes.COMPANY, limit: 50})),
    ]);
    return dispatch({type: Types.LOAD, promise, key});
  },

};



/*
 *  Reducer
 */

const initialState = {
  listingIds: null,
  searchPending: false,
  searchKey: null,
  moreCount: 0,
};

const reducer = reducerUtils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, action) => {
    return {...state,
      searchPending: true,
      searchKey: action.key,
      listingIds: null,
      moreCount: 0,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, action) => {
    if (action.key !== state.searchKey) return state;
    return {...state,
      searchPending: false,
      listingIds: action.result[0].socialPostListings.map(l => l.id),
      moreCount: action.result[0].moreCount,
    };
  },
  [`${Types.LOAD}_REJECTED`]: (state, action) => {
    if (action.key !== state.searchKey) return state;
    return {...state,
      searchPending: false,
    };
  },

});



/*
 *  Selectors
 */

const Slx = (() => {

  const selListingIds    = (state) => state.pageSocialFeed.listingIds;
  const selMoreCount     = (state) => state.pageSocialFeed.moreCount;
  const selSearchPending = (state) => state.pageSocialFeed.searchPending;

  return {
    searchPending: selSearchPending,
    listingIds: selListingIds,
    moreCount: selMoreCount,
  };

})();



export {Types, Ax, reducer, Slx};
export default {Types, Ax, reducer, Slx};
